import { render, staticRenderFns } from "./verbaleFuniCatene.vue?vue&type=template&id=28fbf10a"
import script from "./verbaleFuniCatene.vue?vue&type=script&lang=js"
export * from "./verbaleFuniCatene.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports